export default __webpack_public_path__ + "static/therapeutic-bb460e69febca7a6f18968b67b03bc60.jpeg";